module.exports = __webpack_public_path__ + "img/汕头大学医院附属第一.4c8f138a.png";